import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AuthGaurdService } from './auth-gaurd.service';
import { Observable, of } from 'rxjs';
import { CommPlan } from '../models/commission/comm-plan.model';
import { environment } from '../../environments/environment';
import { CommPlanDetail } from '../models/commission/comm-plan-detail.model';
import { CalendarModel } from '../models/config/calendar.model';
import { KomFeed } from '../models/commission/kom-feed.model';
import { CallDetails } from '../models/commission/call-details.model';
import { tap } from 'rxjs/operators';
import { EarningPotentialModel } from '../models/commission/earningpotential.model';
import { CustomHttpRespone } from '../models/customhttpresponse/custom-http-response';
import { DepndntKpi } from '../models/commission/depndnt-kpi.model';

@Injectable({
    providedIn: 'root'
})
export class CommissionPlanService {

    host: string = environment.apiUrl + 'commission';
    host_commplan: string = environment.apiUrl + 'commplan';

    tokenId: string = '';
    commModel = new CommPlan();
    kpiDetails: CommPlanDetail[] = [];
    salesChannels: string[] = [];
    commData: CommPlan[] = [];
    komFeedModel = new KomFeed();
    editKomFeedModel = new KomFeed();
    loggedinUser: string = '';
    languages: string[];
    payrollCalender: string[];
    salesRepData: KomFeed[];
    callDetailModel = new CallDetails();

    private cache: any = null; // Store cached data

    constructor(private http: HttpClient, private authgurdService: AuthGaurdService) {
        this.tokenId = this.authgurdService.getToken();
    }

    clearCache() {
        console.log("clearCache() Called");
        this.cache = null; // Reset cached data
    }

    public insertCommissionPlan(commPlanModel: CommPlan): Observable<CommPlan> {
        return this.http.post<CommPlan>(`${this.host_commplan}/insertcommplan`, commPlanModel);
    }

    public updateCommPlan(commPlanModel: CommPlan[]): Observable<CommPlan> {
        return this.http.put<CommPlan>(`${this.host_commplan}/updatecommplan`, commPlanModel);
    }

    public updateEp(depndntKpiDtls: EarningPotentialModel[]): Observable<CustomHttpRespone> {
        return this.http.post<CustomHttpRespone>(`${this.host_commplan}/updateep`, depndntKpiDtls);
    }



    public saveDpndntKpiDtls(depndntKpiDtls: DepndntKpi[]): Observable<CustomHttpRespone> {
        return this.http.post<CustomHttpRespone>(`${this.host_commplan}/adddpndntKpitocommplan`, depndntKpiDtls);
    }


    public saveDpndntScoreKpiDtls(formData: FormData): Observable<CustomHttpRespone> {
        return this.http.post<CustomHttpRespone>(`${this.host_commplan}/adddpndntscoreKpitocommplan`, formData);
    }

   

    public saveKpiDetails(commPlanDetailModel: CommPlanDetail[]): Observable<CustomHttpRespone> {
        return this.http.post<CustomHttpRespone>(`${this.host_commplan}/addKpitocommplan`, commPlanDetailModel);
    }

  

    public updateKpiDetails(commPlanDetailModel: CommPlanDetail[]): Observable<CustomHttpRespone> {
        return this.http.put<CustomHttpRespone>(`${this.host_commplan}/updatekpitocommplan`, commPlanDetailModel);
    }

    public deleteKpiDetails(commPlanDetailModels: CommPlanDetail): Observable<CustomHttpRespone> {
        return this.http.post<CustomHttpRespone>(`${this.host_commplan}/deleteKpitocommplan`, commPlanDetailModels);
    }

    // public getAllCommPlansByDate(forceRefresh: boolean = false): Observable<CommPlan[]> {

    //     console.log("Service getAllCommPlansByDate() before");
    //     // Check if the response is already cached
    //     if (!forceRefresh && this.cache) {
    //         return of(this.cache); // Return cached response as an observable
    //     }
    //     console.log("Service getAllCommPlansByDate() after");

    //     return this.http.get<CommPlan[]>(`${this.host}/commplanslist`).pipe(
    //         tap(response => this.cache = response)
    //     );
    // }

}